/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
    Metadata,
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './';

/**
 * Waste specifier object
 * @export
 * @interface WasteSpecifier
 */
export interface WasteSpecifier {
    /**
     * 
     * @type {string}
     * @memberof WasteSpecifier
     */
    readonly id?: string;
    /**
     * Localized specifier names
     * @type {Array<LocalizedValue>}
     * @memberof WasteSpecifier
     */
    localizedNames: Array<LocalizedValue>;
    /**
     * 
     * @type {Metadata}
     * @memberof WasteSpecifier
     */
    metadata: Metadata;
}

export function WasteSpecifierFromJSON(json: any): WasteSpecifier {
    return WasteSpecifierFromJSONTyped(json, false);
}

export function WasteSpecifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): WasteSpecifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'localizedNames': ((json['localizedNames'] as Array<any>).map(LocalizedValueFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function WasteSpecifierToJSON(value?: WasteSpecifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localizedNames': ((value.localizedNames as Array<any>).map(LocalizedValueToJSON)),
        'metadata': MetadataToJSON(value.metadata),
    };
}


